export const SET_DEFAULT_BACKGROUND = 'default_background/set_default_background' as const;

export const setDefaultBackground = (payload: string) => ({
  type: SET_DEFAULT_BACKGROUND,
  payload,
});

export type TSetDefaultBackgroundAction = ReturnType<typeof setDefaultBackground>;
